import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import {
  impersonationLoading,
  impersonationLoaded,
  impersonationError,
  stopImpersonation,
  setHasHandledImpersonation,
  setHasHandledStopImpersonation,
} from "./adminStateActions";

interface AdminState {
  isImpersonating: boolean;
  impersonatedUserEmail: string | null;
  impersonatedUserId: string | null;
  status: "Impersonated" | "Stopped" | "NotStarted";
  hasHandledImpersonation: boolean;
  hasHandledStopImpersonation: boolean;

  loading: boolean;
  error: string | null;
}

const initialState: AdminState = {
  isImpersonating: false,
  impersonatedUserEmail: null,
  loading: false,
  error: null,
  impersonatedUserId: null,
  status: "NotStarted",
  hasHandledImpersonation: false,
  hasHandledStopImpersonation: false,
};

const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(PURGE, () => initialState)
      .addCase(impersonationLoading, (state) => {
        state.loading = true;
        state.error = null;
        state.impersonatedUserEmail = null;
        state.impersonatedUserId = null;
      })
      .addCase(impersonationLoaded, (state, action) => {
        state.loading = false;
        state.isImpersonating = true;
        state.impersonatedUserEmail = action.payload.email;
        state.impersonatedUserId = action.payload.id;
        state.error = null;
        state.status = "Impersonated";
        state.hasHandledImpersonation = false;
      })
      .addCase(impersonationError, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.impersonatedUserEmail = null;
        state.impersonatedUserId = null;
        state.status = "Stopped";
      })
      .addCase(stopImpersonation, (state) => {
        state.isImpersonating = false;
        state.impersonatedUserEmail = null;
        state.impersonatedUserId = null;
        state.error = null;
        state.loading = false;
        state.status = "Stopped";
        state.hasHandledImpersonation = false;
        state.hasHandledStopImpersonation = false;
      })
      .addCase(setHasHandledImpersonation, (state) => {
        state.hasHandledImpersonation = true;
      })
      .addCase(setHasHandledStopImpersonation, (state) => {
        state.hasHandledStopImpersonation = true;
      });
  },
});

export default adminSlice.reducer;
